import Controller from "csi/action/Controller";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";

const MoveToProductHierarchy = declare(Controller, {

	toWriterRequest() {
		const hierarchyDetailParent = this.getParent().__Parent__;
		const fd = this.m_formData;
		const lastField = fd.getFields().pop();
		const fieldVal = lastField.getValue();

		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("ProductHierarchyFolder", xml.ATTR_REF, fieldVal);

		return call;
	},

	postProcessSuccess: function () {
		this.widget.refreshData();
		return this.inherited(arguments);
	},
});

export = MoveToProductHierarchy;